// extracted by mini-css-extract-plugin
export default {"boxes":"Boxes_boxes__Z1fhg"};